import React, { useState } from "react";
import "./SignupPage.css";
import img from "../component/Images/Data extraction-pana 1.png";
import logo from "../component/Images/gore logo (1).jpg";
import apiService from "../services/apiService";


const showNotification = (type, message) => {
    if (
        typeof document === "undefined" ||
        typeof window === "undefined"
    ) {
        return;
    }

    const existingNotification =
        document.getElementById(
            "signup-page-notification"
        );

    if (existingNotification) {
        existingNotification.remove();
    }

    const notification =
        document.createElement("div");

    notification.id =
        "signup-page-notification";

    notification.textContent =
        `${type === "success" ? "✓" : "✕"} ${message}`;

    Object.assign(
        notification.style,
        {
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: "99999",
            minWidth: "280px",
            maxWidth: "420px",
            padding: "12px 16px",
            borderRadius: "8px",
            backgroundColor:
                type === "success"
                    ? "#d1e7dd"
                    : "#f8d7da",
            color:
                type === "success"
                    ? "#0f5132"
                    : "#842029",
            border:
                type === "success"
                    ? "1px solid #badbcc"
                    : "1px solid #f5c2c7",
            fontSize: "14px",
            fontWeight: "600",
            lineHeight: "1.4",
            boxShadow:
                "0 4px 12px rgba(0,0,0,0.15)",
            whiteSpace: "normal",
            wordBreak: "break-word",
        }
    );

    document.body.appendChild(
        notification
    );

    window.setTimeout(() => {
        if (notification.parentNode) {
            notification.remove();
        }
    }, 3000);
};

const getNameParts = (fullName) => {
    const parts = String(fullName || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);

    return {
        firstName:
            parts[0] || "",

        middleName:
            parts.length > 2
                ? parts.slice(1, -1).join(" ")
                : "",

        lastName:
            parts.length > 1
                ? parts[parts.length - 1]
                : "",
    };
};

const getApiErrorMessage = (
    error,
    fallback
) => {
    const data =
        error?.response?.data;

    if (
        typeof data === "string" &&
        data.trim()
    ) {
        return data;
    }

    if (
        data &&
        typeof data === "object"
    ) {
        if (
            data?.errors &&
            typeof data.errors === "object"
        ) {
            const validationErrors =
                Object.entries(data.errors)
                    .flatMap(
                        ([key, value]) => {
                            const messages =
                                Array.isArray(value)
                                    ? value
                                    : [value];

                            return messages.map(
                                (message) =>
                                    `${key}: ${message}`
                            );
                        }
                    )
                    .filter(Boolean)
                    .join(" ");

            if (validationErrors) {
                return validationErrors;
            }
        }

        return (
            data?.failureReason ||
            data?.FailureReason ||
            data?.message ||
            data?.Message ||
            data?.title ||
            data?.error ||
            error?.message ||
            fallback
        );
    }

    return (
        error?.message ||
        fallback
    );
};

export default function SignupPage({
    onBackToLogin,
}) {
    const [
        showPassword,
        setShowPassword,
    ] = useState(false);

    const [
        showConfirmPassword,
        setShowConfirmPassword,
    ] = useState(false);

    const [form, setForm] =
        useState({
            fullName: "",
            email: "",
            phone: "",
            password: "",
            confirmPassword: "",
        });

    const [error, setError] =
        useState("");

    const [success, setSuccess] =
        useState("");

    const [loading, setLoading] =
        useState(false);

    const handleChange = (e) => {
        const {
            name,
            value,
        } = e.target;

        let nextValue = value;

        if (name === "phone") {
            nextValue =
                value.replace(
                    /\D/g,
                    ""
                );

            if (
                nextValue.length > 10
            ) {
                return;
            }
        }

        setForm((prev) => ({
            ...prev,
            [name]:
                nextValue,
        }));

        if (error) {
            setError("");
        }

        if (success) {
            setSuccess("");
        }
    };

    const handleSignup = async (e) => {
        e.preventDefault();

        if (loading) {
            return;
        }

        setError("");
        setSuccess("");

        if (
            !form.fullName.trim() ||
            !form.email.trim() ||
            !form.phone.trim() ||
            !form.password ||
            !form.confirmPassword
        ) {
            const message =
                "All fields are required";

            setError(message);

            showNotification(
                "error",
                message
            );

            return;
        }

        if (
            form.phone.trim().length !== 10
        ) {
            const message =
                "Phone Number must be 10 digits";

            setError(message);

            showNotification(
                "error",
                message
            );

            return;
        }

        if (
            form.password.length < 6
        ) {
            const message =
                "Password must be at least 6 characters";

            setError(message);

            showNotification(
                "error",
                message
            );

            return;
        }

        if (
            form.password !==
            form.confirmPassword
        ) {
            const message =
                "Password and Confirm Password do not match";

            setError(message);

            showNotification(
                "error",
                message
            );

            return;
        }

        const {
            firstName,
            middleName,
            lastName,
        } = getNameParts(
            form.fullName
        );

        const refreshTokenExpiryTime =
            new Date();

        refreshTokenExpiryTime.setDate(
            refreshTokenExpiryTime.getDate() +
            7
        );


        const apiPayload = {
            FirstName: firstName,
            MiddleName: middleName,
            LastName: lastName,

            Email: form.email.trim(),
            Password: form.password,
            MobileNo: form.phone.trim(),

            DateOfBirth: null,

            Hash: null,
            Salt: null,
            Token: null,
            RefreshToken: null,

            IsPasswordSet: true,
            IsFirstTime: true,

            ProfilePic: "",

            RefreshTokenExpiryTime:
                refreshTokenExpiryTime.toISOString(),

            IsActive: 1
        };

        console.log(
            "Signup Add User Request:",
            apiPayload
        );

        try {
            setLoading(true);

            const response =
                await apiService.post(
                    "User/addUser",
                    apiPayload
                );

            const data =
                response?.data;

            console.log(
                "Signup Add User Response:",
                data
            );

            if (
                data?.isSuccess === false ||
                data?.IsSuccess === false
            ) {
                throw new Error(
                    data?.failureReason ||
                    data?.FailureReason ||
                    data?.message ||
                    data?.Message ||
                    "Unable to create account."
                );
            }

            const successMessage =
                data?.message ||
                data?.Message ||
                "Account created successfully.";

            setSuccess(
                successMessage
            );

            showNotification(
                "success",
                successMessage
            );

            setForm({
                fullName: "",
                email: "",
                phone: "",
                password: "",
                confirmPassword: "",
            });

            window.setTimeout(
                () => {
                    onBackToLogin?.();
                },
                1200
            );
        } catch (err) {
            console.error(
                "Signup Add User API Error:",
                err
            );

            console.error(
                "Signup Backend Response:",
                err?.response?.data
            );

            const message =
                getApiErrorMessage(
                    err,
                    "Unable to create account."
                );

            setError(message);

            showNotification(
                "error",
                message
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="signup-container">
            <div className="signup-left">
                <img
                    src={img}
                    alt="Signup Illustration"
                    className="signup-image"
                />
            </div>

            <div className="signup-right">
                <div className="signup-box">
                    <div className="signup-logo">
                        <img
                            src={logo}
                            alt="Logo"
                            className="signup-logo-img"
                        />
                    </div>

                    <h1>
                        Create your account
                    </h1>

                    <p>
                        Please enter your details to create an account.
                    </p>

                    {error && (
                        <p className="signup-error">
                            {error}
                        </p>
                    )}

                    {success && (
                        <p className="signup-success">
                            {success}
                        </p>
                    )}

                    <form
                        onSubmit={
                            handleSignup
                        }
                    >
                        <div className="signup-form-group">
                            <label>
                                Full Name*
                            </label>

                            <input
                                type="text"
                                name="fullName"
                                placeholder="Enter your full name"
                                value={
                                    form.fullName
                                }
                                onChange={
                                    handleChange
                                }
                                disabled={
                                    loading
                                }
                            />
                        </div>

                        <div className="signup-form-group">
                            <label>
                                Email*
                            </label>

                            <input
                                type="email"
                                name="email"
                                placeholder="Enter your email"
                                value={
                                    form.email
                                }
                                onChange={
                                    handleChange
                                }
                                disabled={
                                    loading
                                }
                            />
                        </div>

                        <div className="signup-form-group">
                            <label>
                                Phone Number*
                            </label>

                            <input
                                type="tel"
                                name="phone"
                                placeholder="Enter your phone number"
                                value={
                                    form.phone
                                }
                                onChange={
                                    handleChange
                                }
                                maxLength={10}
                                inputMode="numeric"
                                disabled={
                                    loading
                                }
                            />
                        </div>

                        <div className="signup-form-group">
                            <label>
                                Password*
                            </label>

                            <div className="signup-password-box">
                                <input
                                    type={
                                        showPassword
                                            ? "text"
                                            : "password"
                                    }
                                    name="password"
                                    placeholder="6 symbols at least"
                                    value={
                                        form.password
                                    }
                                    onChange={
                                        handleChange
                                    }
                                    disabled={
                                        loading
                                    }
                                />

                                <span
                                    className="signup-eye"
                                    onClick={() => {
                                        if (
                                            !loading
                                        ) {
                                            setShowPassword(
                                                !showPassword
                                            );
                                        }
                                    }}
                                >
                                    👁
                                </span>
                            </div>
                        </div>

                        <div className="signup-form-group">
                            <label>
                                Confirm Password*
                            </label>

                            <div className="signup-password-box">
                                <input
                                    type={
                                        showConfirmPassword
                                            ? "text"
                                            : "password"
                                    }
                                    name="confirmPassword"
                                    placeholder="6 symbols at least"
                                    value={
                                        form.confirmPassword
                                    }
                                    onChange={
                                        handleChange
                                    }
                                    disabled={
                                        loading
                                    }
                                />

                                <span
                                    className="signup-eye"
                                    onClick={() => {
                                        if (
                                            !loading
                                        ) {
                                            setShowConfirmPassword(
                                                !showConfirmPassword
                                            );
                                        }
                                    }}
                                >
                                    👁
                                </span>
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="signup-btn"
                            disabled={
                                loading
                            }
                        >
                            {loading
                                ? "Creating Account..."
                                : "Create Account"}
                        </button>
                    </form>

                    <div className="signup-login-text">
                        Already have an account?{" "}

                        <button
                            type="button"
                            className="signup-login-link"
                            onClick={
                                onBackToLogin
                            }
                            disabled={
                                loading
                            }
                        >
                            Log in
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}